import { injectWarning } from './warning'

if (!window.location.host) {
  // User has saved the page as a local copy to their desktop
  injectWarning()

  // This stops the loading of the app
  throw new Error('Running from filesystem is unsupported')
}
